import { compose } from "redux";
import { connect } from "react-redux";
import debounce from "lodash/debounce";
import { Grid } from "@material-ui/core";
import React, { PureComponent } from "react";
import { reduxForm } from "redux-form/immutable";
import { withStyles } from "@material-ui/core/styles";

import {
  employeeCardDetailsOnLoad,
  employeeDetailsFormOnChange,
} from "features/planner/employee/employee.actions";

import BasePage from "app/components/BasePage";
import { ACTIONS } from "features/planner/planner.constants";
import { getActionDataStateFromState } from "app/app.selectors";
import { UPDATE_EMPLOYEE_FORM } from "features/planner/employee/employee.constants";
import EmployeeForm from "features/planner/employee/general/components/EmployeeForm";
import DepartureForm from "features/planner/employee/general/components/DepartureForm";
import { getEmployeeCardFromState } from "features/planner/employee/employee.selectors";
import PersonaliaForm from "features/planner/employee/general/components/PersonaliaForm";

class EmployeeGeneralInfo extends PureComponent {
  componentDidMount() {
    const { dispatchOnLoad, employeeCard } = this.props;

    dispatchOnLoad(employeeCard.get("employee"));
  }

  render() {
    const { Icon, employeeCard, dataState } = this.props;

    return (
      <BasePage Icon={Icon} title={null} dataState={dataState}>
        <Grid container spacing={4}>
          <PersonaliaForm
            classes={{
              root: this.props.classes.formRoot,
            }}
          />
          <EmployeeForm
            classes={{
              root: this.props.classes.formRoot,
            }}
            markers={employeeCard.getIn(["employee", "markers"])}
          />
          <DepartureForm
            classes={{
              root: this.props.classes.formRoot,
            }}
          />
        </Grid>
      </BasePage>
    );
  }
}

EmployeeGeneralInfo.defaultProps = {
  markers: {},
};

const styles = () => ({
  formRoot: {
    display: "block",
  },
});

export default compose(
  connect(
    (state, { employeeCardId }) => ({
      dataState: getActionDataStateFromState(state, ACTIONS.GET_CARD),
      employeeCard: getEmployeeCardFromState(state, employeeCardId),
    }),
    {
      dispatchOnLoad: employeeCardDetailsOnLoad,
    },
  ),
  reduxForm({
    form: UPDATE_EMPLOYEE_FORM.ID,
    onChange: debounce(employeeDetailsFormOnChange, 1500),
  }),
  withStyles(styles),
)(EmployeeGeneralInfo);
